import styled from 'styled-components'
import { Box } from '@mui/material'

export const TruncateBox = styled(Box)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`
